import React, { useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { AppState } from '../../../../store';
import { onGetTopSeller } from '../../../../store/actions/TopSeller';
import Box from '@mui/material/Box';
import CircularProgressBar from '../../../../common/CircularProgress';

const useStyles = makeStyles({
  root: {
    padding: '0px'
  },
  topSellerImage: {
    width: '100%',
    height: '260px',
    minHeight: '210px'
  },
  customLegendCSS: {
    fontSize: '16px !important',
    backgroundColor: 'transparent !important'
  }
});

const TopSellers = () => {
    const classes = useStyles()
    const dispatch = useDispatch();

    const {topSellers} = useSelector<AppState, AppState['products']>(
        ({products}) => products,
    );
    const {loading} = useSelector<AppState, AppState['common']>(
        ({common}) => common,
    );
    useEffect(() => {
        if(!topSellers || topSellers.length === 0) {
            dispatch(onGetTopSeller())
        }
    }, [topSellers, dispatch])
    return <>
        <Box p={.1}>
            {/* <Box component="h5" mb={0}>Top Sellers</Box> */}
        </Box>
        {loading && <CircularProgressBar />}
        {!loading && topSellers && topSellers.length === 0 && <h6>No Top Seller Found!</h6>}
        {!loading && topSellers && topSellers.length > 0 &&
            <Carousel autoPlay={true} infiniteLoop={true}>
                {topSellers.map((ts: any) => {
                    return <div className={classes.root} key={ts._id}>
                        <img className={classes.topSellerImage} src={ts.seller.logo} alt={ts.seller.name} />
                        <p className={clsx("legend", classes.customLegendCSS)}>{ts.seller.name}</p>
                    </div>
                })}
            </Carousel>
        }
    </>
}

export default TopSellers;
